import { createIconComponent } from '../../factory/create-icon-component';
export const RadioSelectedIcon = createIconComponent(
  'RadioSelectedIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="12" cy="12" r="4" fill="currentColor" />
  </svg>,
);
